import SimpleParallax from "simple-parallax-js/vanilla";

export default class ImageParallax {
    constructor(selectors) {
        this.defaultOptions = {
            orientation: 'down', // 'up'
            scale: 1.2,
            overflow: false,
            delay: 0.4,
            transition: 'cubic-bezier(0,0,0,1), opacity .6s ease-in',
            maxTransition: 200,
            customContainer: null,
            customWrapper: null,
            breakpoint: false
        };

        this.init(selectors);
    }

    init(selectors) {
        selectors.forEach(selector => {
            let options = this.defaultOptions;

            // override default options with any that are passed
            if (Array.isArray(selector)) {
                [selector, options] = selector;
                options = { ...this.defaultOptions, ...options };
            }

            document.querySelectorAll(selector).forEach(element => {
                if (getComputedStyle(element).display !== 'none') {
                    new SimpleParallax(element, options);
                }
            });
        });
    }
}